import { AdjustmentNoteCategoryEnum } from "@gtpl/shared-models/common-models";

export class AdjustmentNoteViewModel{
    adjutsmentNoteId:number
    invoiceNum:string
    poNumber:string
    poId:number
    vendorId:number
    vendorCode:string
    vendorName:string
    category: AdjustmentNoteCategoryEnum
    debitNoteNum: string
    creditNoteNum:string
    itemsInfo:AdjustmentNoteItemInfo[]

    constructor(adjutsmentNoteId:number,invoiceNum:string,poNumber:string,poId:number,vendorId:number,vendorCode:string,vendorName:string,category: AdjustmentNoteCategoryEnum,debitNoteNum: string,creditNoteNum:string,itemsInfo:AdjustmentNoteItemInfo[]){
        this.adjutsmentNoteId = adjutsmentNoteId
        this.invoiceNum = invoiceNum
        this.poNumber = poNumber
        this.poId = poId
        this.vendorId = vendorId
        this.vendorCode = vendorCode
        this.vendorName = vendorName
        this.itemsInfo = itemsInfo
        this.category = category
        this.debitNoteNum = debitNoteNum
        this.creditNoteNum = creditNoteNum
    }

}

export class AdjustmentNoteItemInfo{
    
    saleOrderNum:string
    saleOrderId:number
    itemId:number
    itemName:string
    price:number
    quantity:number
    taxAmount:number
    totalAmount:number
    taxPer : number
    grnItemId:number
    grnId:number
    grnNum:string

    constructor(saleOrderNum:string,saleOrderId:number,itemId:number,itemName:string,price:number,quantity:number,taxAmount:number,totalAmount:number,taxPer : number,grnItemId:number,grnId:number,grnNum:string){
        
        this.saleOrderNum = saleOrderNum
        this.saleOrderId = saleOrderId
        this.itemId = itemId
        this.itemName = itemName
        this.price = price
        this.quantity = quantity
        this.taxAmount = taxAmount
        this.totalAmount = totalAmount
        this.taxPer  = taxPer 
        this.grnItemId = grnItemId
        this.grnId = grnId
        this.grnNum = grnNum
    }
}